import { render } from "./Table.vue?vue&type=template&id=8ca5fa00"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"
script.render = render

export default script